<template>
    <!-- 发布渠道信息弹窗start -->
    <div class="g-popup g-popup-transparent js-popup-transparent" style="display: block;" v-show="show">
        <div class="popup-con channel-popup">
            <div class="popup-close js-close-channel" @click="close"><i class="ico ico-close"></i></div>
            <h5 class="popup-title">发布渠道信息</h5>
            <div class="channel-info">
                <p class="list">
                    <label class="label">媒体</label>
                    {{ data.mediaName }}
                </p>
                <p class="list">
                    <label class="label">账号</label>
                    {{ data.accountName }}
                </p>
                <p class="list">
                    <label class="label">*封面图</label>
                    <img :src="data.outCover" width="312" alt="">
                </p>
                <p class="list">
                    <label class="label">*标题</label>
                    {{ data.outTitle }}
                </p>
                <p class="list" v-if="data.outDesc">
                    <label class="label">简介</label>
                    {{ data.outDesc }}
                </p>
                <p class="list">
                    <label class="label">*标签</label>
                    <span class="tag" v-for="tag in data.outTags" :key="tag">{{ tag }}</span>
                </p>
            </div>
        </div>
    </div>
        <!-- 发布渠道信息弹窗end -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/components/pop/channel_detail.scss';
</style>
<script>
export default {
    data() {
        return {
            data: {},
            show: false
        }
    },
    components: {},
    mounted(){
            
    },
    methods: {
        getList(data){
            this.data = data;
        },
        close(){
            this.show = false;
        }
    }
}
</script>